export const observeDOM = (function() {
  const MutationObserverCtor = window.MutationObserver;

  return function(obj: Node, callback: MutationCallback): MutationObserver | void {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserverCtor) {
      // define a new observer
      const mutationObserver = new MutationObserverCtor(callback)

      // have the observer observe for changes in children
      mutationObserver.observe(obj, { childList:true, subtree:true })
      return mutationObserver
    } else {
      // browser support fallback
      obj.addEventListener('DOMNodeInserted', callback as unknown as EventListener, false)
      obj.addEventListener('DOMNodeRemoved', callback as unknown as EventListener, false)
    }
  }
})();
